import { render, staticRenderFns } from "./customReading.vue?vue&type=template&id=51babfb2"
import script from "./customReading.ts?vue&type=script&lang=js&external"
export * from "./customReading.ts?vue&type=script&lang=js&external"
import style0 from "./customReading.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports